import { gql } from '@apollo/client';

export const GET_TREE = gql`
query tree($dataId:String!,$dataType:DataType!) {
  getTree(dataId:$dataId, dataType:$dataType) {
    namespace
    nodes {
      key
      namespace
      dataRef {
        type
        dataId
        data:dataId
      }
      meta {
        key
        value
      }
    }
    edges {
      dataRef {
        type
        dataId
        data:dataId
      }
      previous
      next
      key
      default
    }
    dataRef {
      type
      dataId
      data:dataId
    }
  }
}
`;
